export default __webpack_public_path__ + "static/media/arrowBox.612fc77e.svg";